import { useNavigate } from "react-router-dom";
import {
  ArrowLeft,
  BadgeIndianRupee,
  CalendarDays,
  Download,
  Package,
  Target,
  Trophy,
} from "lucide-react";
import { formatEarningsCurrency } from "../earningsAdapters";
import "./SalarUnityIncentives.css";

const SalarUnityDetails = () => {
  const navigate = useNavigate();
  const progress = 100;

  return (
    <section className="salar-unity-page">
      <div className="salar-unity-shell">
        <header className="salar-unity-page-header salar-unity-details-header">
          <div className="salar-unity-title-wrap">
            <button
              type="button"
              className="salar-unity-back-button"
              onClick={() => navigate("/SalarUnity")}
              aria-label="Back to Salar Unity Incentives"
            >
              <ArrowLeft size={20} />
            </button>
            <div>
              <span className="salar-unity-eyebrow">SALAR UNITY</span>
              <h1>Salar Unity Incentive Details</h1>
              <p>
                Complete achievement, voucher, SUR and bonus incentive
                information.
              </p>
            </div>
          </div>
          <span className="salar-unity-status salar-unity-status-completed">
            Success
          </span>
        </header>

        <div className="salar-unity-details-grid">
          <section className="salar-unity-detail-card salar-unity-detail-card-order">
            <div className="salar-unity-detail-heading">
              <CalendarDays size={20} />
              <div>
                <span>ORDER & ACHIEVEMENT</span>
                <h2>Purchase Information</h2>
              </div>
            </div>
            <div className="salar-unity-detail-kv-grid">
              <div>
                <span>Order Date</span>
                <strong>01-08-2025</strong>
                <small>12:13 pm IST</small>
              </div>
              <div>
                <span>Order ID</span>
                <strong>SA-220325-517501-CA61</strong>
              </div>
              <div>
                <span>Date</span>
                <strong>01-08-2025</strong>
                <small>12:13 pm IST</small>
              </div>
              <div>
                <span>Milestone</span>
                <strong>Milestone - 1</strong>
              </div>
              <div>
                <span>Order Type</span>
                <strong>Original</strong>
              </div>
            </div>
          </section>

          <section className="salar-unity-detail-card salar-unity-detail-product">
            <div className="salar-unity-detail-heading">
              <Package size={20} />
              <div>
                <span>PRODUCT INFORMATION</span>
                <h2>Shopping Voucher</h2>
              </div>
            </div>
            <div className="salar-unity-detail-product-row">
              <img src="../../assets/img/mobiles/mobiles-4.png" alt="" />
              <div>
                <span className="salar-unity-section-label">
                  PRODUCT NAME
                </span>
                <h3>Salar Shopping Voucher</h3>
                <p>
                  Salar Code: <strong>S34O251</strong>
                </p>
                <strong className="salar-unity-detail-price">
                  {formatEarningsCurrency(22000)}
                </strong>
              </div>
            </div>
          </section>

          <section className="salar-unity-detail-card">
            <div className="salar-unity-detail-heading">
              <BadgeIndianRupee size={20} />
              <div>
                <span>RECEIVED INCENTIVES</span>
                <h2>SUR Incentive</h2>
              </div>
            </div>
            <div className="salar-unity-incentive-highlight">
              <span>Milestone - 1</span>
              <strong>{formatEarningsCurrency(500)}</strong>
              <small>Received SUR Incentive</small>
            </div>
          </section>

          <section className="salar-unity-detail-card">
            <div className="salar-unity-detail-heading">
              <Target size={20} />
              <div>
                <span>BONUS SUR INCENTIVE</span>
                <h2>Target Progress</h2>
              </div>
            </div>
            <div className="salar-unity-target-grid">
              <div>
                <span>Target Days</span>
                <strong>10</strong>
              </div>
              <div>
                <span>Achieved Days</span>
                <strong>10</strong>
              </div>
            </div>
            <div className="salar-unity-progress-track">
              <span style={{ width: `${progress}%` }} />
            </div>
            <div className="salar-unity-bonus-total">
              <span>Received Bonus SUR Incentive</span>
              <strong>{formatEarningsCurrency(500)}</strong>
            </div>
          </section>
        </div>

        <section className="salar-unity-detail-footer-card">
          <div>
            <Trophy size={20} />
            <div>
              <strong>Achievement Summary</strong>
              <span>Milestone - 1 · Salar Unity</span>
            </div>
          </div>
          <button type="button">
            <Download size={17} />
            Download Payout Receipt
          </button>
        </section>
      </div>
    </section>
  );
};

export default SalarUnityDetails;
